import { hydra } from '@/lib/services/Hydra'
import { getCountryBasedStoreCredit } from '@/lib/utils/user/getCountryBasedStoreCredit'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect } from 'react'
import { usePriceHandler } from '../helpers/usePriceHandler'

export const useGetStoreCredit = () => {
  const {
    app: { alpha3 },
    user: { token, customer },
    setLoaders,
    setUser,
  } = useGlobalStore()
  const { priceHandler } = usePriceHandler()

  useEffect(() => {
    if (!token) return
    ;(async () => {
      const market = customer?.mainAddress?.country || 'US'

      setLoaders({ isLoadingStoreCredit: true })

      try {
        const storeCreditRaw = await hydra.getStoreCredit({
          market,
          hydraToken: token,
        })

        if (storeCreditRaw && storeCreditRaw.items[0]) {
          setUser({ storeCredit: storeCreditRaw })

          const countryBasedStoreCredit = getCountryBasedStoreCredit({
            alpha3,
            storeCreditResponse: storeCreditRaw,
          })

          if (countryBasedStoreCredit) {
            const storeCredit = priceHandler({
              returnFreeIfPriceIsZero: false,
              price:
                countryBasedStoreCredit.storeCredit > 0
                  ? countryBasedStoreCredit.storeCredit
                  : 0,
              currency: countryBasedStoreCredit.availableCurrency,
            })

            setUser({
              formattedStoreCredit: storeCredit.toString(),
              rawStoreCredit: countryBasedStoreCredit.storeCredit,
            })
          } else {
            setUser({
              formattedStoreCredit: null,
              rawStoreCredit: null,
            })
          }
        }
      } catch {
      } finally {
        setLoaders({ isLoadingStoreCredit: false })
      }
    })().catch(() => {})
  }, [alpha3, customer?.mainAddress?.country, setUser, token])
}
